/* eslint-disable */
//Global Imports
import axios from "axios";
//End Global Imports
import Cookies from "universal-cookie";
import { decryptData, encryptData } from "../utils";
import store from "../app/store";
import { clearAuth } from "../pages/remittance-beta/state/authSlice";
import MixpanelConfig from "../constants/MixpanelConfig";

const cookies = new Cookies();

const baseAPIUrl = process.env.REACT_APP_SERVER_ID;

let validationKey: any = null;
let validationArray: any[] = [];

export const Axios = axios.create({
  baseURL: baseAPIUrl,
  headers: {
    // "Access-Control-Allow-Origin": "true",
    "Content-Type": "application/json",
    accept: "*/*",
    "X-Route-To": "remittance",
  },
  withCredentials: true,
});

Axios.interceptors.request.use(
  function (request: any) {
    validationKey = window.crypto
      .getRandomValues(new Uint32Array(1))[0]
      .toString();
    validationArray.push(validationKey);
    if (request?.data && !(request?.data instanceof FormData)) {
      let validatedRequest = { ...request?.data, validationKey: validationKey };
      let newValidatedRequest = {
        data: request?.data,
        validationKey: validationKey,
      };
      const requestData = JSON.stringify(newValidatedRequest);
      const encryptedRequest = encryptData(requestData);
      const requestObj = JSON.stringify({ data: encryptedRequest });
      request.data = requestObj;
      const addressBarURL = window.location.href;
      MixpanelConfig.trackEvent(request?.baseURL + request?.url, {
        addressBarURL: addressBarURL,
        requestData: newValidatedRequest,
        baseURL: request?.baseURL,
        apiURL: request?.url,
        params: request?.params,
        method: request?.method,
        data: request?.data,
        type: "Request"
      });
      return request;
    } else {
      request.headers = { ...request.headers, validationKey: validationKey };
      return request;
    }
  },
  function (error) {
    window.console.error("request interceptor error", error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    if (response.config.responseType === "blob") {
      return response;
    } else {
      // Handle other response types
      const decryptResponse = decryptData(
        response.data.body ? response.data.body : ""
      );
      response["data"] = decryptResponse?.data;
      if (validationArray.includes(decryptResponse?.validationKey)) {
        const index = validationArray.indexOf(decryptResponse?.validationKey);
        let newArray: any[] = [];
        if (index > -1) {
          newArray = [
            ...validationArray.slice(0, index),
            ...validationArray.slice(index + 1),
          ];
        }
        validationArray = newArray;
        const modifiedResponse = {
          ...response,
          success: response?.data?.success,
        };
        const addressBarURL = window.location.href;
        const apiUrl = `${response?.config?.baseURL ?? ""}${response?.config?.url ?? ""}`;
        MixpanelConfig.trackEvent(apiUrl, {
          addressBarURL: addressBarURL,
          responseData: response?.data,
          baseURL: response?.config?.baseURL,
          apiURL: response?.config?.url,
          params: response?.config?.params,
          method: response?.config?.method,
          type: "Response"
        });
        return modifiedResponse;
      } else {
        alert("Not Authorized");
        localStorage.clear();
        sessionStorage.clear();
        store.dispatch(clearAuth());
        window.location.href = "/auth/sign-in-new";
        MixpanelConfig.trackEvent("Not Authorized 401", {});
        return response;
      }
    }
  },
  async function (error) {
    if (
      error?.response?.config?.responseType === "blob" &&
      error?.response?.headers["content-type"] === "application/json"
    ) {
      try {
        const errorText = await error.response.data.text();
        console.error("error text", errorText);
        const errorJSON = JSON.parse(errorText);
        // error.response.data = errorJSON;
        const newBody = errorJSON?.body;
        const decryptedData = decryptData(newBody);
        console.error("error data", decryptedData);
        const addressBarURL = window.location.href;
        const apiUrl = `${error?.response?.config?.baseURL ?? ""}${error?.response?.config?.url ?? ""}`;
        MixpanelConfig.trackEvent(apiUrl, {
          addressBarURL: addressBarURL,
          responseData: error?.response?.data,
          baseURL: error?.response?.config?.baseURL,
          apiURL: error?.response?.config?.url,
          params: error?.response?.config?.params,
          method: error?.response?.config?.method,
          type: "Response",
          error: "Error from the API",
          errorData: decryptedData
        });
        return Promise.reject(decryptedData);
      } catch (blobError) {
        console.error("Error converting blob to text", blobError);
      }
    }
    if (
      error?.response?.headers["content-type"] === "application/octet-stream" ||
      error?.config.url ==
        "https://dev-assisted-api.moneyhop.co/remit/user/4165/kycdocsandlogs/export/pdf"
    ) {
      return Promise.reject(error);
    } else {
      const decryptResponse = decryptData(
        error?.response?.data?.body ? error?.response?.data?.body : ""
      );
      // if (decryptResponse?.data?.error?.code === 9999) {
      //   alert("Logging out because you logged in from another device");
      //   localStorage.clear();
      //   sessionStorage.clear();
      //   window.location.href = "/auth/sign-in";
      // }
      const modifiedData = decryptResponse;
      error.response = modifiedData;
      const modifiedResponse = { ...error, message: error?.message };
      const addressBarURL = window.location.href;
      const apiUrl = `${error?.response?.config?.baseURL ?? ""}${error?.response?.config?.url ?? ""}`;
      MixpanelConfig.trackEvent(apiUrl, {
        addressBarURL: addressBarURL,
        responseData: error?.response?.data,
        baseURL: error?.response?.config?.baseURL,
        apiURL: error?.response?.config?.url,
        params: error?.response?.config?.params,
        method: error?.response?.config?.method,
        type: "Response",
        error: "Error from the API",
        errorData: modifiedResponse
      });
      return Promise.reject(modifiedResponse);
    }
  }
);
